import React from 'react';

/**
 * Hook to avoid boilerplate code in hooks to use stores.
 * @param storeContext
 * @param storeName
 */
export const useProvidedStore = <T>(storeContext: React.Context<T>, storeName: string): T => {
  const store = React.useContext(storeContext);
  if (!store) {
    throw new Error(`Trying to use ${storeName} outside of a StoreProvider.`);
  }
  return store;
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/common/src/hook/use-provided-store.ts